import React from 'react';
import './_avatarcard.scss';

const AvatarCard = ({children}) => (
    <div className="avatar--wrapper">
        <div className="avatar--card">
            {children}
        </div>
    </div>
)

export default AvatarCard


// WEBPACK FOOTER //
// ./src/components/avatargrid/card/index.jsx